//Image to SVG
function imgToSvg() {
  let convertImages = (query, callback) => {
    let images = document.querySelectorAll("img.svg");
    images.forEach((image) => {
      fetch(image.src)
        .then((res) => res.text())
        .then((data) => {
          let parser = new DOMParser();
          let svg = parser
            .parseFromString(data, "image/svg+xml")
            .querySelector("svg");
          svg.setAttribute(
            "viewBox",
            "0 0 " +
              svg.getAttribute("width") +
              " " +
              svg.getAttribute("height"),
          );
          if (image.id) svg.id = image.id;
          if (image.className) svg.classList = image.classList;
          image.parentNode.replaceChild(svg, image);
        })
        .then(callback);
    });
  };
  convertImages("img");
}

// Header sticky on scroll
let lastScrollTop = 0;
const headerSticky = () => {
  if ($(".header").length > 0) {
    let scrollTop = $(window).scrollTop();
    const header = $(".header");

    if (scrollTop > 10) {
      header.addClass("is-sticky");
    } else {
      header.removeClass("is-sticky");
    }
    lastScrollTop = scrollTop;
  }
};

// keenslider navigation
function navigation(slider) {
  let wrapper, dots, arrowLeft, arrowRight;

  function markup(remove) {
    wrapperMarkup(remove);
    dotMarkup(remove);
    arrowMarkup(remove);
  }

  function removeElement(elment) {
    elment.parentNode.removeChild(elment);
  }
  function createButton(className) {
    var div = document.createElement("button");
    var classNames = className.split(" ");
    classNames.forEach((name) => div.classList.add(name));
    return div;
  }
  function createDiv(className) {
    var div = document.createElement("div");
    var classNames = className.split(" ");
    classNames.forEach((name) => div.classList.add(name));
    return div;
  }

  function arrowMarkup(remove) {
    if (remove) {
      removeElement(arrowLeft);
      removeElement(arrowRight);
      return;
    }
    arrowLeft = createButton("arrow arrow--left");
    arrowLeft.setAttribute("tabindex", "0");
    arrowLeft.setAttribute("aria-label", "previous slide");
    arrowLeft.setAttribute("role", "button");
    arrowLeft.addEventListener("click", () => slider.prev());
    arrowLeft.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        arrowLeft.click();
      }
    });
    arrowRight = createButton("arrow arrow--right");
    arrowRight.setAttribute("tabindex", "0");
    arrowRight.setAttribute("aria-label", "next slide");
    arrowRight.setAttribute("role", "button");
    arrowRight.addEventListener("click", () => slider.next());
    arrowRight.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        arrowRight.click();
      }
    });

    innerWrapper.appendChild(arrowLeft);
    innerWrapper.appendChild(arrowRight);
  }

  function wrapperMarkup(remove) {
    if (remove) {
      var parent = wrapper.parentNode;
      while (wrapper.firstChild)
        parent.insertBefore(wrapper.firstChild, wrapper);
      removeElement(wrapper);
      return;
    }
    wrapper = createDiv("slider-wrapper");
    innerWrapper = createDiv("slider-navigation");
    slider.container.parentNode.appendChild(wrapper);
    wrapper.appendChild(slider.container);
    wrapper.appendChild(innerWrapper);
  }

  function dotMarkup(remove) {
    if (remove) {
      removeElement(dots);
      return;
    }
    dots = createDiv("dots");
    slider.track.details.slides.forEach((_e, idx) => {
      var dot = createButton("dot");
      dot.setAttribute("tabindex", "0");
      dot.setAttribute("aria-label", "navigate to slide " + (idx + 1));
      dot.addEventListener("click", () => slider.moveToIdx(idx));
      dot.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          dot.click();
        }
      });
      dots.appendChild(dot);
    });
    innerWrapper.appendChild(dots);
  }

  function updateClasses() {
    var slide = slider.track.details.rel;
    slide === 0
      ? arrowLeft.classList.add("arrow--disabled")
      : arrowLeft.classList.remove("arrow--disabled");
    slide === slider.track.details.slides.length - 1
      ? arrowRight.classList.add("arrow--disabled")
      : arrowRight.classList.remove("arrow--disabled");
    Array.from(dots.children).forEach(function (dot, idx) {
      idx === slide
        ? dot.classList.add("dot--active")
        : dot.classList.remove("dot--active");
    });
  }

  slider.on("created", () => {
    markup();
    updateClasses();
  });
  slider.on("optionsChanged", () => {
    console.log(2);
    markup(true);
    markup();
    updateClasses();
  });
  slider.on("slideChanged", () => {
    updateClasses();
  });
  slider.on("destroyed", () => {
    markup(true);
  });
}
// keenslider init
function newsSlider() {
  if ($(".fhw.slider").length > 0) {
    var slider = new KeenSlider(
      "#newsSlider",
      {
        breakpoints: {
          "(min-width: 500px)": {
            slides: { perView: 2, spacing: 10 },
          },
          "(min-width: 991px)": {
            slides: { perView: 3.125, spacing: 32, origin: "center" },
          },
        },
        loop: true,
        slides: { perView: 1.12, spacing: 10 },
      },
      [navigation],
    );
  }
}

function current__year() {
  if ($("#year").length > 0) {
    var date = new Date();
    var year = date.getFullYear();
    document.getElementById("year").innerHTML = year;
  }
}

//Cursor
function cursorClick() {
  $("a").each(function () {
    let href = $(this).attr("href");
    if (!href || href === "#" || href === "#0" || href === "#!") {
      $(this).addClass("is-unclickable");
    }
  });
}

function accordion() {
  if ($(".jsAccordion").length > 0) {
    const accordionButtons = $(".jsAccordion .jsAccordionButton");

    // Initialize accordion state
    accordionButtons.each(function (index) {
      const $button = $(this);
      const $listItem = $button.parent();
      const $content = $button.next("article");

      if (index === 0) {
        // First item active by default
        $listItem.addClass("active");
        $button.attr("aria-expanded", "true");
        $content.attr("aria-hidden", "false");
      } else {
        // Hide all other items
        $listItem.removeClass("active");
        $button.attr("aria-expanded", "false");
        $content.attr("aria-hidden", "true").hide();
      }
    });

    // Add click handlers to all accordion headers
    accordionButtons.on("click", function (e) {
      e.preventDefault();
      const $control = $(this);
      const $listItem = $control.parent();
      const $content = $control.next("article");

      // Check if current item is already active
      const isActive = $listItem.hasClass("active");

      // Close all other accordion items
      closeOthers($control[0]);

      // Toggle current item
      if (isActive) {
        // Close current item
        $listItem.removeClass("active");
        $control.attr("aria-expanded", "false");
        $content.attr("aria-hidden", "true").slideUp();
      } else {
        // Open current item
        $listItem.addClass("active");
        $control.attr("aria-expanded", "true");
        $content.attr("aria-hidden", "false").slideDown();
      }
    });

    // Function to close all other accordion items
    function closeOthers(currentElement) {
      accordionButtons.each(function () {
        const $button = $(this);
        const $listItem = $button.parent();
        const $content = $button.next("article");

        if (this !== currentElement) {
          $listItem.removeClass("active");
          $button.attr("aria-expanded", "false");
          $content.attr("aria-hidden", "true").slideUp();
        }
      });
    }
  }
}

// Slick Slider Init
function newsSliderSlick() {
  const $slider = $(".jsNewsSlider");

  if (!$slider.length) return;

  const totalSlides = $slider.find(".news-listing__item").length;

  $slider.slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    prevArrow: '<button type="button" class="slick-prev slick-nav-btn"></button>',
    nextArrow: '<button type="button" class="slick-next slick-nav-btn"></button>',
    arrows: totalSlides > 3, // show arrows only if more than 3 cards
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          arrows: totalSlides > 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows: totalSlides > 1,
        }
      }
    ]
  });

  // Hide/Show arrows at start & end positions
  $slider.on("afterChange", function (event, slick, currentSlide) {
    const $prev = $slider.find(".slick-prev");
    const $next = $slider.find(".slick-next");

    // hide left arrow when at the start
    if (currentSlide === 0) {
      $prev.hide();
    } else {
      $prev.show();
    }

    // hide right arrow when at the end
    if (currentSlide >= slick.slideCount - slick.options.slidesToShow) {
      $next.hide();
    } else {
      $next.show();
    }
  });

  // run once on load to adjust initial state
  $slider.trigger("afterChange", [ { slideCount: totalSlides, options: $slider.slick("getSlick").options }, 0 ]);
}



$(document).ready(function () {
  // imgToSvg();
  current__year();
});

$(window).on("load", function () {
  cursorClick();
  accordion();
  newsSliderSlick();
});
(function () {
  let isActive = false;
  let viewLink, popup, closeBtn, content;
  let scrollPosition = 0;

  // Helper functions to disable/enable page scroll (pure JS)
  function disablePageScroll() {
    scrollPosition = window.scrollY || document.documentElement.scrollTop;
    document.body.dataset.scrollPosition = scrollPosition;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function enablePageScroll() {
    const scrollY = parseInt(document.body.dataset.scrollPosition || '0', 10);
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  // Handler functions so we can remove them if needed
  function showPopup(e) {
    e.preventDefault();
    popup.classList.remove("hidden");
    disablePageScroll();
  }

  function closePopup() {
    popup.classList.add("hidden");
    enablePageScroll();
  }

  function outsideClick(e) {
    if (!content.contains(e.target)) {
      popup.classList.add("hidden");
      enablePageScroll();
    }
  }

  // ESC key handler
  function handleEscKey(e) {
    if (e.key === "Escape" && popup && !popup.classList.contains("hidden")) {
      closePopup();
    }
  }

  function bindPopupEvents() {
    if (!isActive && viewLink && popup && closeBtn && content) {
      viewLink.addEventListener("click", showPopup);
      closeBtn.addEventListener("click", closePopup);
      popup.addEventListener("click", outsideClick);
      document.addEventListener("keydown", handleEscKey);
      isActive = true;
    }
  }

  function unbindPopupEvents() {
    if (isActive && viewLink && popup && closeBtn && content) {
      viewLink.removeEventListener("click", showPopup);
      closeBtn.removeEventListener("click", closePopup);
      popup.removeEventListener("click", outsideClick);
      document.removeEventListener("keydown", handleEscKey);
      popup.classList.add("hidden");
      enablePageScroll();
      isActive = false;
    }
  }

  function imagepopupInit() {
    viewLink = document.querySelector(".jsImageViewLink");
    popup = document.querySelector(".jsImagePopup");

    if (!popup || !viewLink) {
      unbindPopupEvents();
      return;
    }

    closeBtn = popup.querySelector(".jsImageCloseButton");
    content = popup.querySelector(".jsImagePopupContent");

    if (!closeBtn || !content) {
      unbindPopupEvents();
      return;
    }

    if (window.innerWidth < 991) {
      bindPopupEvents();
    } else {
      unbindPopupEvents();
    }
  }

  document.addEventListener("DOMContentLoaded", imagepopupInit);
  window.addEventListener("resize", imagepopupInit);
})();

document.addEventListener("DOMContentLoaded", function() {
    const popup = document.querySelector(".jsImagePopupBanner");
    const closeButton = document.querySelector(".jsImageCloseButtonBanner");
    const popupContent = document.querySelector(".jsImagePopupContentBanner");
    if (!popup || !closeButton || !popupContent) {
        return;
    }
    // Check if user has already closed it
    if (localStorage.getItem("webinarPopupClosed") === "true") return;

    // Show after 10 seconds
    setTimeout(() => {
        popup.classList.remove("hidden");
        $('body').css('overflow', 'hidden');
    }, 10000);

    // Close on X button
    closeButton.addEventListener("click", () => {
        popup.classList.add("hidden");
        $('body').css('overflow', 'auto');
        localStorage.setItem("webinarPopupClosed", "true");
    });

    // Close on clicking outside the popup content (on the overlay)
    popup.addEventListener("click", (e) => {
        if (e.target === popup) {
            popup.classList.add("hidden");
            $('body').css('overflow', 'auto');
            localStorage.setItem("webinarPopupClosed", "true");
        }
    });

    // Optional: Close on ESC key
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && !popup.classList.contains("hidden")) {
            popup.classList.add("hidden");
            $('body').css('overflow', 'auto');
            localStorage.setItem("webinarPopupClosed", "true");
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const cookiePopup = document.querySelector(".cookie-pop-up");
  const cookieBtn = document.querySelector(".cookie-pop-up__actions button");

  if (!cookiePopup || !cookieBtn) return;

  function disableScroll() {
    document.body.style.overflow = "hidden";
  }

  function enableScroll() {
    document.body.style.overflow = "";
  }

  // Show popup only if not accepted
  if (localStorage.getItem("cookieAccepted")) {  console.log("cookie")
    cookiePopup.classList.remove("is-visible");
    enableScroll();
  }else{
    cookiePopup.classList.add("is-visible");
    disableScroll();
  }

  // Button event
  cookieBtn.addEventListener("click", function () {
    cookiePopup.classList.remove("is-visible");
    enableScroll();
    localStorage.setItem("cookieAccepted", "true");
  });
});
